/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CourseEntity } from '../models/CourseEntity';
import type { InstructorEntity } from '../models/InstructorEntity';
import type { InstructorInvitationEntity } from '../models/InstructorInvitationEntity';
import type { MeetingEntity } from '../models/MeetingEntity';
import type { PostInstructorDto } from '../models/PostInstructorDto';
import type { PostInstructorInvitationDto } from '../models/PostInstructorInvitationDto';
import type { UpdateInstructorDto } from '../models/UpdateInstructorDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class InstructorService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get all Instructors
     * @returns InstructorEntity Instructors have been returned
     * @throws ApiError
     */
    public instructorControllerGetInstructorsV1(): CancelablePromise<Array<InstructorEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/instructor',
            errors: {
                404: `Instructor has not been found`,
            },
        });
    }
    /**
     * Create an Instructor
     * @param requestBody
     * @returns InstructorEntity Instructor has been created
     * @throws ApiError
     */
    public instructorControllerCreateInstructorV1(
        requestBody: PostInstructorDto,
    ): CancelablePromise<InstructorEntity> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/instructor',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get an Instructor
     * @param instructorId
     * @returns InstructorEntity Instructor has been returned
     * @throws ApiError
     */
    public instructorControllerGetInstructorV1(
        instructorId: string,
    ): CancelablePromise<InstructorEntity> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/instructor/{instructorId}',
            path: {
                'instructorId': instructorId,
            },
            errors: {
                404: `Instructor has not been found`,
            },
        });
    }
    /**
     * Delete an Instructor
     * @param instructorId
     * @returns InstructorEntity Instructor has been deleted
     * @throws ApiError
     */
    public instructorControllerDeleteInstructorV1(
        instructorId: string,
    ): CancelablePromise<InstructorEntity> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/v1/instructor/{instructorId}',
            path: {
                'instructorId': instructorId,
            },
            errors: {
                404: `Instructor has not been found`,
            },
        });
    }
    /**
     * Update an instructor
     * @param instructorId
     * @param requestBody
     * @returns InstructorEntity Instructor has been updated
     * @throws ApiError
     */
    public instructorControllerUpdateInstructorV1(
        instructorId: string,
        requestBody: UpdateInstructorDto,
    ): CancelablePromise<InstructorEntity> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/v1/instructor/{instructorId}',
            path: {
                'instructorId': instructorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get all courses an instructor is teaching
     * @param instructorId
     * @returns CourseEntity Instructor has been deleted
     * @throws ApiError
     */
    public instructorControllerGetInstructorCoursesV1(
        instructorId: string,
    ): CancelablePromise<Array<CourseEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/instructor/{instructorId}/courses',
            path: {
                'instructorId': instructorId,
            },
        });
    }
    /**
     * Claim an Instructor
     * @param instructorId
     * @returns InstructorInvitationEntity The claimed Instructor
     * @throws ApiError
     */
    public instructorControllerClaimInstructorV1(
        instructorId: string,
    ): CancelablePromise<InstructorInvitationEntity> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/instructor/{instructorId}/claim',
            path: {
                'instructorId': instructorId,
            },
        });
    }
    /**
     * Get all (non expired) meetings an instructor is teaching
     * @param instructorId
     * @returns MeetingEntity Instructor has been deleted
     * @throws ApiError
     */
    public instructorControllerGetInstructorMeetingsV1(
        instructorId: string,
    ): CancelablePromise<Array<MeetingEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/instructor/{instructorId}/meetings',
            path: {
                'instructorId': instructorId,
            },
        });
    }
    /**
     * Get all Instructor Invitations
     * @returns InstructorInvitationEntity Instructor Invitations have been returned
     * @throws ApiError
     */
    public instructorControllerGetInstructorInvitationsV1(): CancelablePromise<Array<InstructorInvitationEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/instructor/invitation',
        });
    }
    /**
     * Create an Instructor Invitation
     * @param requestBody
     * @returns InstructorInvitationEntity Instructor Invitation has been created
     * @throws ApiError
     */
    public instructorControllerCreateInstructorInvitationV1(
        requestBody: PostInstructorInvitationDto,
    ): CancelablePromise<InstructorInvitationEntity> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/instructor/invitation',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete an Instructor Invitation
     * @param instructorInvitationId
     * @returns InstructorInvitationEntity The deleted Instructor Invitation
     * @throws ApiError
     */
    public instructorControllerInvalidateInvitationV1(
        instructorInvitationId: string,
    ): CancelablePromise<InstructorInvitationEntity> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/v1/instructor/invitation/{instructorInvitationId}',
            path: {
                'instructorInvitationId': instructorInvitationId,
            },
        });
    }
}
